module.exports = __webpack_public_path__ + "public/Icons/clockDark.svg?56055048";